import React from "react";
import HelpButton from "@/components/HelpButton/HelpButton";
import { PageHeaderNew } from "@/components/PageHeader/PageHeaderNew";
import { useParams } from "react-router-dom";
import { packagingLabel } from "@/utilities/packaging";
import styles from "@/pages/packaging/detail/PackagingDetails.module.scss";
import { formatMass } from "@/pages/dashboard/utils/formatters";
import { Flex, Tooltip } from "antd";
import { PieChartOutlined } from "@ant-design/icons";
import { PACKAGING_BREADCRUMBS } from "@/pages/packaging/packagingBreadcrumbs";
import { useGetPackaging } from "@/pages/packaging/usePackagings";
import PackagingDetailTabs from "@/pages/packaging/detail/PackagingDetailTabs";
import { Outlet } from "react-router";
import Skeleton from "@/components/Skeleton/Skeleton";
import StatusTag from "@/components/StatusTag/StatusTag";

function PackagingDetails() {
  let { packagingId: id } = useParams();
  const packagingId = Number(id);

  const { data, isLoading: packagingIsLoading } = useGetPackaging({ packagingId });
  // const { data: packagingImpact, isLoading: impactIsLoading } = usePackagingImpact({
  //   packagingId,
  // });

  const usedMassIcon = (
    <Tooltip title="Mass used in product calculations">
      <PieChartOutlined />
    </Tooltip>
  );

  return (
    <div className={styles.ProductDetail}>
      <PageHeaderNew
        loading={packagingIsLoading}
        title={data ? packagingLabel(data?.external_id, data?.name) : ""}
        breadcrumbsRight={
          <HelpButton
            url="/"
            type="text"
          />
        }
        breadcrumbs={PACKAGING_BREADCRUMBS}
      >
        <Flex justify="space-between">
          <div className={styles.attributes}>
            <span className={styles.attribute}>
              <span className={styles.title}>BOM mass</span>
              <span className={styles.value}>
                {data?.bom_mass ? formatMass(data?.bom_mass) : "-"}
                {data?.bom_mass && usedMassIcon}
              </span>
            </span>
            <span className={styles.attribute}>
              <span className={styles.title}>Product relations</span>
              <span className={styles.value}>{data?.relations}</span>
            </span>
          </div>
          <Flex
            gap={8}
            align="center"
          >
            {packagingIsLoading ? (
              <Skeleton style={{ width: "90px", height: "24px" }} />
            ) : (
              data && (
                <StatusTag
                  background="white"
                  status={data.status}
                  showIcon={false}
                />
              )
            )}
          </Flex>
        </Flex>
      </PageHeaderNew>
      <div className={styles.tabs}>
        <PackagingDetailTabs packagingId={packagingId} />
      </div>

      <Outlet />
    </div>
  );
}

export default PackagingDetails;
